import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-white py-10 px-4 md:px-8 text-center" data-id="element-173">
      <div className="max-w-4xl mx-auto" data-id="element-174">
        <h2 className="text-green-600 font-bold text-xl uppercase tracking-wider mb-1" data-id="element-175">
          La Solución
        </h2>

        <h3 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-176">
          🏫 KIT COMPLETO PRIMARIA LISTA
        </h3>

        <p className="text-xl md:text-2xl text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-177">
          Sistema integral de planificaciones y actividades diseñadas para
          primaria, de 1° a 6° grado.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl mx-auto" data-id="element-178">
          {['Listo', 'Organizado', 'Aplicable', 'Pensado para docentes reales'].map((item, i) => <div key={i} className="bg-green-50 text-green-800 font-bold py-3 px-2 rounded-lg border border-green-200" data-id="element-179">
              ✔ {item}
            </div>)}
        </div>
      </div>
    </section>;
}